import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-gray-300 py-8" data-testid="main-footer">
      <div className="max-w-5xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-6">
          {/* Left - Praxis Münster */}
          <div>
            <h4 className="text-white font-medium mb-3 text-sm uppercase tracking-wide">Praxis Münster</h4>
            <p className="text-sm leading-relaxed">
              Gremmendorfer Weg 83<br />
              48167 Münster
            </p>
          </div>

          {/* Center - Praxis Borken */}
          <div>
            <h4 className="text-white font-medium mb-3 text-sm uppercase tracking-wide">Praxis Borken</h4>
            <p className="text-sm leading-relaxed">
              Butenwall 52A<br />
              46325 Borken
            </p>
          </div>

          {/* Right - Contact */}
          <div>
            <h4 className="text-white font-medium mb-3 text-sm uppercase tracking-wide">Kontakt</h4>
            <p className="text-sm leading-relaxed">
              Katharina Langer<br />
              Tel: +49 157 51336474<br />
              <a 
                href="mailto:Psychotherapie-Praxis-langer@gmx.de" 
                className="hover:text-white transition-colors"
              >
                Psychotherapie-Praxis-langer@gmx.de
              </a>
            </p>
          </div>
        </div>

        {/* Bottom Links */}
        <div className="border-t border-gray-700 pt-4 flex flex-col sm:flex-row justify-between items-center text-sm">
          <p className="text-gray-500 mb-2 sm:mb-0">
            © {new Date().getFullYear()} Katharina Langer · Psychologische Psychotherapeutin
          </p>
          <div className="flex items-center gap-4">
            <Link to="/impressum" className="text-gray-400 hover:text-white transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-gray-400 hover:text-white transition-colors">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
